import {
  BIG_PLAY_BUTTON,
  CARD,
  CardDefinition,
  IMAGE,
  ImageDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TAB,
  TabDefinition,
  TABS,
  TEXT,
  VIDEO,
  VideoDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { isIOS, isSafari } from 'react-device-detect';

export const Interactive2: Translator = sequence => {
  const root = translate(sequence, () => null);
  const tabs: TabDefinition[] = [];
  let iterator = 0;
  const tabsTitles: string[] = [];

  sequence.items?.forEach(item => {
    if (item.__typename == 'Tab') {
      tabsTitles.push(item.title || '');

      const items: Array<VideoDefinition | ImageDefinition | CardDefinition> =
        [];

      if (item.videos && item.videos.length) {
        items.push({
          id: `video_${item.id}`,
          type: VIDEO,
          values: {
            isolated: true,
            mediaUrl:
              isIOS || isSafari
                ? ([
                    item.videos[0].mediaUrl && {
                      src: item.videos[0].mediaUrl,
                      type: 'video/mp4'
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ].filter(Boolean) as any)
                : ([
                    item.videos[0].hlsUrl && {
                      src: item.videos[0].hlsUrl,
                      type: 'application/vnd.apple.mpegurl'
                    },
                    item.videos[0].mediaUrl && {
                      src: item.videos[0].mediaUrl,
                      type: 'video/mp4'
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ].filter(Boolean) as any),
            subtitlesUrl:
              item.videos && item.videos.length
                ? item.videos[0].subtitlesUrl
                : null,
            autoPlay: false,
            showProgress: true,
            showPlayButton: true,
            videoContainerStyles: {
              width: '300px',
              height: '500px',
              position: 'relative',
              borderRadius: '20px'
            }
          },
          items: []
        } as VideoDefinition);
      }

      if (item.audios) {
        items.push({
          type: IMAGE,
          id: `img_${item.id}`,
          items: [
            {
              id: item.id,
              type: LAYOUT_LIST,
              values: { align: 'center', height: { _: 'auto', lg: '100%' } },
              items: [
                {
                  type: BIG_PLAY_BUTTON,
                  id: `${item.id}_audios`,
                  values: {
                    showProgress: true,
                    mediaUrl: item.audios?.[0]?.mediaUrl,
                    subtitlesUrl: item.audios?.[0]?.subtitlesUrl
                  },
                  items: []
                }
              ]
            }
          ],
          values: {
            url: item.pictures?.[0].mediaUrl,
            alt: item.pictures?.[0].name
          }
        } as ImageDefinition);
      } else {
        if (item.pictures && item.pictures.length) {
          items.push({
            type: IMAGE,
            id: `img_${item.id}`,
            items: [],
            values: {
              url: item.pictures?.[0].mediaUrl,
              alt: item.pictures?.[0].name
            }
          } as ImageDefinition);
        }
      }

      items.push({
        type: CARD,
        id: `card_${item.id}`,
        values: {
          clearStyles: 'xs',
          height: '100%',
          width: '100%',
          padding: 0,
          borderRadius: 0
        },
        items: [
          {
            type: LAYOUT_LIST,
            id: `${sequence.id}.cardlist`,
            values: {
              orientation: 'column',
              align: {
                _: 'top left',
                md: 'left'
              }
            },
            items: [
              {
                type: TEXT,
                id: `${item.id}_subtitle`,
                items: [],
                values: {
                  value: item.subtitle,
                  variant: 'sub_heading',
                  icon: item.icon
                }
              },
              {
                type: TEXT,
                id: `${item.id}_body`,
                items: [],
                values: {
                  value: item.body
                }
              }
            ]
          }
        ]
      });

      tabs.push({
        type: TAB,
        id: `tab_${item.id}`,
        items: [
          {
            type: LAYOUT_COLUMNS,
            id: `LAYOUT_COLUMNS_${item.id}`,
            values: {},
            items: items
          }
        ],
        values: {
          iterator,
          value: item.title || ''
        }
      });

      iterator++;
    }
  });

  root.items.push({
    id: 'LAYOUT_LIST',
    type: LAYOUT_LIST,
    values: {
      align: 'center'
    },
    items: [
      {
        type: TABS,
        id: 'TABS',
        values: {
          tabsTitles
        },
        items: tabs
      }
    ]
  });

  return root;
};
